import { Callout } from '../../../../../components/Callout';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';

type NoServiceVehiclesCalloutProps = {
  vehiclesWithoutServicesCount: number;
  onClick: () => void;
  onClose: () => void;
};

export const NoServiceVehiclesCallout = ({
  vehiclesWithoutServicesCount,
  onClose,
  onClick,
}: NoServiceVehiclesCalloutProps) => (
  <Callout
    data-testid="your-insights-no-service-vehicles"
    type="secondary"
    title={
      <CustomFormattedMessage
        id={
          vehiclesWithoutServicesCount !== 1
            ? 'overview.yourSimplePay.noServiceVehicles.title.plural'
            : 'overview.yourSimplePay.noServiceVehicles.title.singular'
        }
        values={{ count: vehiclesWithoutServicesCount }}
      />
    }
    description={
      <CustomFormattedMessage id="overview.yourSimplePay.noServiceVehicles.description" />
    }
    onClick={onClick}
    onClose={onClose}
  />
);
